export default "__VITE_ASSET__BVrPkCMT__"